import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '../..';
import Theme from '../../Theme';
/**
 * Renders a label with an icon for an input.
 *
 * @return {jsx}
 */

var Label = function Label(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, label.icon && /*#__PURE__*/React.createElement(Icon, {
    name: label.icon,
    color: Theme.palette.mediumGrey,
    width: "1.6rem",
    height: "1.6rem"
  }), !label.icon && label.text && /*#__PURE__*/React.createElement("span", null, label.text));
};
/** Display name. */


Label.displayName = 'Input.Label';
/**Prop types. */

var string = PropTypes.string,
    shape = PropTypes.shape;
Label.propTypes = {
  className: string.isRequired,
  label: shape({
    text: string,
    icon: string
  })
};
/** Default props. */

Label.defaultProps = {
  label: {
    text: ''
  }
};
export default styled(Label).withConfig({
  displayName: "Label",
  componentId: "sc-1cciyce-0"
})(["display:flex;align-items:center;justify-content:center;padding:1.1rem;color:", ";background:", ";", ";", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.darkGrey;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.paleGrey;
}, function (_ref4) {
  var position = _ref4.position;
  return position === 'left' && css(["border-right:1px solid ", ";"], function (_ref5) {
    var palette = _ref5.theme.palette;
    return palette.lightGrey;
  });
}, function (_ref6) {
  var position = _ref6.position;
  return position === 'right' && css(["border-left:1px solid ", ";"], function (_ref7) {
    var palette = _ref7.theme.palette;
    return palette.lightGrey;
  });
});